module.exports = "/assets/data/1a66eb7adf416e75d28f35265db721d5-FK5.data.json";